import { render, staticRenderFns } from "./QuickSearchMaterial.vue?vue&type=template&id=162f7347"
import script from "./QuickSearchMaterial.vue?vue&type=script&lang=js"
export * from "./QuickSearchMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports